import axios from 'axios';

export default {
    methods: {
        async precioOrigenIndex(ok, err) {
            try {
                let r = await axios.get('precio-origen');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenStore(d, ok, err) {
            try {
                let r = await axios.post('precio-origen', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenUpdate(d, ok, err) {
            try {
                let r = await axios.put('precio-origen/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenDestroy(id, ok, err) {
            try {
                let r = await axios.delete('precio-origen/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenDatos(ok, err) {
            try {
                let r = await axios.post('precio-origen/datos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenBusqueda(d, ok, err) {
            try {
                let r = await axios.post('precio-origen/busqueda', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async precioOrigenInforme(ok, err) {
            try {
                let r = await axios.post('precio-origen/informe');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/precio_origen.js